import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Grid,
  Box,
  TextField,
  FormControl
} from "@mui/material";
import { Breadcrumb, SimpleCard } from "app/components";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {
  getAttendanceDetailById,
  updateCheckIn,
} from "app/redux/actions";
import Loading from "app/components/MatxLoading";
import { useAuth } from 'app/hooks/useAuth';
import { PATH } from "../../../config";
import * as Yup from "yup";
import { Formik } from "formik";

function EditCheck() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useAuth();
  const { id } = useParams();

  const loggedInUser = useSelector((state) => state.user.user);
  const { attendanceDetail, loading: attendanceLoading } = useSelector(
    (state) => state.attendance
  );

  const initialValues = useMemo(() => {
    let breakTimeDate = null;
    if (attendanceDetail?.breakTime && attendanceDetail.breakTime > 0) {
      const totalSeconds = attendanceDetail.breakTime;
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      breakTimeDate = dayjs().hour(hours).minute(minutes).second(0);
    }

    return {
      userId: attendanceDetail?.userId || "",
      date: attendanceDetail?.date ? dayjs(attendanceDetail.date) : null,
      checkIn: attendanceDetail?.checkIn ? dayjs(attendanceDetail.checkIn) : null,
      checkOut: attendanceDetail?.checkOut ? dayjs(attendanceDetail.checkOut) : null,
      breakTime: breakTimeDate,
      notes: attendanceDetail?.notes || "",
    };
  }, [attendanceDetail]);


  useEffect(() => {
    if (id && loggedInUser?.token) {
      dispatch(getAttendanceDetailById(id));
    }
  }, [dispatch, id, loggedInUser]);
  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      userId:
        loggedInUser?.userType === "admin"
          ? Yup.string().required("Employee selection is required.")
          : Yup.string().nullable(),

      checkIn: Yup.date()
        .required("Check-in time is required.")
        .nullable(),

      checkOut: Yup.date()
        .nullable()
        .min(Yup.ref("checkIn"), "Check-out time cannot be before check-in time."),

      date: Yup.date().nullable(),
      breakTime: Yup.date().nullable(),
      notes: Yup.string().nullable(),
    });
  }, [loggedInUser]);

  useEffect(() => {
    if (attendanceDetail) {
      let breakTimeDate = null;
      if (attendanceDetail.breakTime && attendanceDetail.breakTime > 0) {
        const totalSeconds = attendanceDetail.breakTime;
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);

        breakTimeDate = dayjs().hour(hours).minute(minutes).second(0);
      }
    }
  }, [attendanceDetail]);


  // const handleSubmit = () => {
  //   const { date, checkIn, checkOut, breakTime, notes } = values;

  //   const combinedCheckIn =
  //     checkIn && date
  //       ? dayjs(date).hour(dayjs(checkIn).hour()).minute(dayjs(checkIn).minute())
  //       : null;

  //   const combinedCheckOut =
  //     checkOut && date
  //       ? dayjs(date).hour(dayjs(checkOut).hour()).minute(dayjs(checkOut).minute())
  //       : null;

  //   let breakTimeInSeconds = 0;
  //   if (breakTime) {
  //     const hours = dayjs(breakTime).hour();
  //     const minutes = dayjs(breakTime).minute();
  //     breakTimeInSeconds = (hours * 3600) + (minutes * 60);
  //   }

  //   const payload = {
  //     date: date ? date.format("YYYY-MM-DD") : null,
  //     checkIn: combinedCheckIn ? combinedCheckIn.toISOString() : null,
  //     checkOut: combinedCheckOut ? combinedCheckOut.toISOString() : null,
  //     breakTime: breakTimeInSeconds,
  //     notes: notes,
  //     id
  //   };

  //   dispatch(updateCheckIn(id, payload));
  //   if (auth.userType === 'admin') {
  //     navigate(PATH.AllCHECK);
  //   } else {
  //     navigate(-1);
  //   }
  // };

  if (attendanceLoading || !attendanceDetail) {
    return <Loading />;
  }

  return (
    <SimpleCard>
      <Box>
        <Breadcrumb routeSegments={[{ name: "Edit Attendance" }]} />
      </Box>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const { date, checkIn, checkOut, breakTime, notes } = values;

          const combinedCheckIn =
            checkIn && date
              ? dayjs(date).hour(dayjs(checkIn).hour()).minute(dayjs(checkIn).minute())
              : null;

          let combinedCheckOut = null;
          if (checkOut && date) {
            let tempCheckOut = dayjs(date).hour(dayjs(checkOut).hour()).minute(dayjs(checkOut).minute());

            if (tempCheckOut.isBefore(combinedCheckIn)) {
              tempCheckOut = tempCheckOut.add(1, 'day');
            }
            combinedCheckOut = tempCheckOut;
          }

          let breakTimeInSeconds = 0;
          if (breakTime) {
            const hours = dayjs(breakTime).hour();
            const minutes = dayjs(breakTime).minute();
            breakTimeInSeconds = (hours * 3600) + (minutes * 60);
          }

          const payload = {
            date: date ? date.format("YYYY-MM-DD") : null,
            checkIn: combinedCheckIn ? combinedCheckIn.toISOString() : null,
            checkOut: combinedCheckOut ? combinedCheckOut.toISOString() : null, // Use the corrected value
            breakTime: breakTimeInSeconds,
            notes: notes,
            id,
          };

          dispatch(updateCheckIn(id, payload));
          // onSubmit={(values) => {
          //   const { date, checkIn, checkOut, breakTime, notes } = values;

          //   const combinedCheckIn =
          //     checkIn && date
          //       ? dayjs(date).hour(dayjs(checkIn).hour()).minute(dayjs(checkIn).minute())
          //       : null;

          //   const combinedCheckOut =
          //     checkOut && date
          //       ? dayjs(date).hour(dayjs(checkOut).hour()).minute(dayjs(checkOut).minute())
          //       : null;

          //   let breakTimeInSeconds = 0;
          //   if (breakTime) {
          //     const hours = dayjs(breakTime).hour();
          //     const minutes = dayjs(breakTime).minute();
          //     breakTimeInSeconds = (hours * 3600) + (minutes * 60);
          //   }

          //   const payload = {
          //     date: date ? date.format("YYYY-MM-DD") : null,
          //     checkIn: combinedCheckIn ? combinedCheckIn.toISOString() : null,
          //     checkOut: combinedCheckOut ? combinedCheckOut.toISOString() : null,
          //     breakTime: breakTimeInSeconds,
          //     notes: notes,
          //     id,
          //   };

          //   dispatch(updateCheckIn(id, payload));

          if (auth.userType === 'admin') {
            navigate(PATH.AllCHECK);
          } else {
            navigate(-1);
          }
        }}
        enableReinitialize
      >

        {({
          values,
          handleChange,
          handleSubmit,
          setFieldValue,
          errors
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Box padding={2}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Employee"
                      value={attendanceDetail?.User?.name || "Loading name..."}
                      fullWidth
                      disabled
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  {auth.userType === 'admin' ?
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Date"
                        type="date"
                        fullWidth
                        value={values.date ? values.date.format("YYYY-MM-DD") : ""}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    :
                    <Grid item xs={12} md={6}>
                      <TextField
                        label="Date"
                        type="date"
                        fullWidth
                        disabled
                        value={values.date ? values.date.format("YYYY-MM-DD") : ""}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>}
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          label="Check In Time"
                          value={values.checkIn}
                          onChange={(newValue) => setFieldValue("checkIn", newValue)}
                          renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          label="Check Out Time"
                          value={values.checkOut}
                          onChange={(newValue) => setFieldValue("checkOut", newValue)}
                          renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          label="Break Time"
                          ampm={false}
                          views={['hours', 'minutes']}
                          value={values.breakTime}
                          onChange={(newValue) => setFieldValue("breakTime", newValue)}
                          slotProps={{ textField: { fullWidth: true } }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>

                  {/* Notes field */}
                  <Grid item xs={12}>
                    <TextField
                      label="Notes"
                      multiline
                      rows={4}
                      value={values.notes}
                      onChange={(e) => setFieldValue("notes", e.target.value)}
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Button
                  variant="contained"
                  type="submit"
                  style={{ marginTop: 24 }}
                >
                  Update Check-in
                </Button>
              </Box>
            </form>
          )
        }}
      </Formik>
    </SimpleCard>
  );
}

export default EditCheck;